import { Button, Grid, Paper, TextField } from "@mui/material";
import styles from "./styles.module.css";
import { CadastroContext } from "../../config/Context/CadastroContext";
import { useContext, useEffect, useState } from "react";
import { formatValue } from "../../utils/formatValue";
import { useNavigate } from "react-router-dom";
import { retornarEnderecoPeloCep } from "../../services/address.service";
import InputMask from "react-input-mask";
import { LoginContext } from "../../config/Context/LoginContext";
import SnackBar from "../../components/SnackBar";

const CadastroClienteSimples = () => {
  const { dados, setDados } = useContext(CadastroContext);
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  const navigate = useNavigate();
  const isCnpj = dados.tipoDocumento === "cnpj";

  const handleSnackBar = (obj) => {
    setObjSnackBar(obj);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDados({ ...dados, [name]: value });
  };

  const handleChangeCep = async (e) => {
    const value = e.target.value.replace(/\D/g, "");

    if (!value) {
      setDados({
        ...dados,
        cep: value,
        logradouro: "",
        bairro: "",
        cidade: "",
        estado: "",
        codIbge: "",
      });
      return;
    }

    if (value.length === 8) {
      try {
        const endereco = await retornarEnderecoPeloCep(value);
        setDados({
          ...dados,
          cep: value,
          logradouro: endereco.logradouro,
          bairro: endereco.bairro,
          cidade: endereco.localidade,
          estado: endereco.uf,
          codIbge: endereco.ibge,
        });
      } catch (error) {
        handleSnackBar({
          type: "error",
          msg: "Erro ao buscar endereço pelo CEP. Tente novamente.",
        });
        console.error(error);
      }
    } else {
      setDados({ ...dados, cep: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    navigate("/selecionar-tipos-negocio-simples");
  };

  useEffect(() => {
    isCnpj && handleChangeCep({ target: { value: dados.cep } });
  }, []);
  return (
    <>
      <div className={styles.container}>
        <Paper sx={{ padding: "1rem" }}>
          <div className={styles.header}>
            <h3>Cadastro Simples de Cliente</h3>
          </div>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item lg={2} md={2} sm={6} xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  name="tipoDocumento"
                  value={dados[dados.tipoDocumento] || ""}
                  label={dados.tipoDocumento.toUpperCase()}
                  disabled
                />
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  name="nome"
                  value={dados.nome || ""}
                  label={
                    dados.tipoDocumento === "cnpj" ? "Razão Social" : "Nome"
                  }
                  disabled={isCnpj}
                  required
                />
              </Grid>
              {isCnpj && (
                <Grid item lg={2} md={2} sm={6} xs={12}>
                  <TextField
                    size="small"
                    fullWidth
                    onChange={handleChange}
                    name="dtAbertura"
                    value={
                      dados.dtAbertura
                        ? formatValue("data", dados.dtAbertura)
                        : ""
                    }
                    label="Data de Abertura"
                    disabled
                  />
                </Grid>
              )}
              <Grid item lg={isCnpj ? 2 : 4} md={isCnpj ? 2 : 4} sm={6} xs={12}>
                <InputMask
                  mask="99999-999"
                  value={dados.cep || ""}
                  onChange={handleChangeCep}
                  disabled={isCnpj}
                >
                  {() => (
                    <TextField
                      disabled={isCnpj}
                      size="small"
                      fullWidth
                      name="cep"
                      label="CEP"
                      required
                      inputProps={{ 'data-only': 'numeric' }}
                    />
                  )}
                </InputMask>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  name="logradouro"
                  value={dados.logradouro || ""}
                  label="Logradouro"
                  disabled={isCnpj}
                  required
                />
              </Grid>
              <Grid item lg={2} md={2} sm={6} xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  name="numero"
                  value={dados.numero || ""}
                  label="Número"
                  disabled={isCnpj}
                  required
                  inputProps={{ 'data-only': 'numeric' }}
                />
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  name="complemento"
                  value={dados.complemento || ""}
                  label="Complemento"
                  disabled={isCnpj}
                />
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  name="bairro"
                  value={dados.bairro || ""}
                  label="Bairro"
                  disabled={isCnpj}
                  required
                />
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  name="cidade"
                  value={dados.cidade || ""}
                  label="Cidade"
                  disabled={isCnpj}
                  required
                />
              </Grid>
              <Grid item lg={2} md={2} sm={6} xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  name="estado"
                  value={dados.estado || ""}
                  label="Estado"
                  disabled={isCnpj}
                  required
                />
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  type="email"
                  name="email"
                  value={dados.email || ""}
                  label="E-mail"
                  required
                />
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={12}>
                <TextField
                  size="small"
                  fullWidth
                  onChange={handleChange}
                  name="telefone"
                  value={dados.telefone || ""}
                  label="Telefone/ Celular"
                  inputProps={{ 'data-only': 'numeric' }}
                />
              </Grid>
            </Grid>
            <div className={styles.containerBtn}>
              <Button
                variant="outlined"
                className={styles.btnBack}
                onClick={() => navigate("/cadastrar-cnpj")}
              >
                Voltar
              </Button>
              <Button
                variant="contained"
                type="submit"
                className={styles.btnForward}
              >
                Prosseguir
              </Button>
            </div>
          </form>
        </Paper>
      </div>
      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />
    </>
  );
};

export default CadastroClienteSimples;
